/**
 * Auth Feature Module
 * SCR-801, SCR-802, SCR-803, SCR-804
 */

// Pages
export { RegistrationPage } from './pages/RegistrationPage';
export { TermsAcceptancePage } from './pages/TermsAcceptancePage';
export { ForgotPasswordPage } from './pages/ForgotPasswordPage';
export { ChangePasswordPage } from './pages/ChangePasswordPage';

// Aliases for routes compatibility
export { RegistrationPage as Register } from './pages/RegistrationPage';
export { ForgotPasswordPage as ForgotPassword } from './pages/ForgotPasswordPage';

// Placeholder components for routes (to be implemented)
export const Login = () => null;
export const AuthCallback = () => null;

// Hooks
export * from './hooks/useAuth';

// Types
export * from './types';
